import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserState } from './user.state';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectIsAuthenticated = createSelector(
  selectUserState,
  (state: UserState) => state.auth.isAuthenticated
);

export const selectLoginData = createSelector(
  selectUserState,
  (state: UserState) => state.auth.loginData
);

export const selectUserUuid = createSelector(
  selectLoginData,
  (loginData) => loginData?.userUuid || null
);

export const selectCurrentUser = createSelector(
  selectUserState,
  (state: UserState) => state.currentUser
);

export const selectLoading = createSelector(
  selectUserState,
  (state: UserState) => state.loading
);

export const selectError = createSelector(
  selectUserState,
  (state: UserState) => state.error
);

export const selectLastUpdated = createSelector(
  selectUserState,
  (state: UserState) => state.lastUpdated
);

export const selectSelectedContract = createSelector(
  selectUserState,
  (state: UserState) => state.selectedContract
);

export const selectSelectedContractDetails = createSelector(
  selectUserState,
  (state: UserState) => state.selectedContractDetails
);
